

(function () {
    'use strict';

    angular
        .module('app')
        .service('ListViewSearchExtension', ListViewSearchExtension);

    ListViewSearchExtension.$inject = ['$state',];

    function ListViewSearchExtension($state) {
        var service = this;

        service.extendScope = extendScope;

        function extendScope(vm){
            vm.listObject = {
                filter: '',
                page: 1,
                perPage: 10,
                searchTerm: '',
            };
            vm.listMeta = {};
            vm.clearSearch = clearSearch;
            vm.search = search;
            vm.loadPage = loadPage;
            vm.loadParams = loadParams;
            vm.onSearch = onSearch;

            function loadParams(params){
                if(angular.isObject(params) && !angular.equals(params, {})){
                    angular.extend(vm.listObject, params);
                }
            }

            function onSearch(){
                $state.go('.', { searchObject: JSON.stringify(vm.listObject) });
            }

            function clearSearch() {
                vm.listObject.searchTerm = '';
                vm.listObject.page = 1;
                vm.loadResources();
            }

            function search() {
                vm.listObject.page = 1;
                vm.loadResources();
            }

            function loadPage(newPageNumber) {
                vm.listObject.page = newPageNumber;
                vm.loadResources();
            }
        }

    }

})();